import Table from 'admin/components/atoms/Table';
import Pager from 'admin/components/shared/Pager';
import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { getOrganizationApplicationTemplates } from '~/javascripts/admin/actions/merchant-application-templates';
import { getFrontEnv } from '~/javascripts/admin/utils';
import { createBadge } from '../../../atoms/Badge';

type GetOrganizationApplicationTemplatesResponse = Awaited<
  ReturnType<typeof getOrganizationApplicationTemplates>
>;

type Props = {
  applications: GetOrganizationApplicationTemplatesResponse['rows'];
  pagination?: GetOrganizationApplicationTemplatesResponse['pagination'];
  onChangePage: (page: number) => void;
};

const LinkText = styled.a`
  ${({ theme }) => css`
    ${theme.typography.body2.regular}
    color: ${theme.semanticColors.text.primary} !important;
    text-decoration: underline !important;
  `}
`;

const StatusBadge = createBadge({
  draft: {
    bgColor: '#666666',
    color: 'white',
    label: '非公開',
  },
  active: {
    bgColor: '#21BF25',
    color: 'white',
    label: '公開中',
  },
});

const getBaseUrl = () => {
  const env = getFrontEnv();
  const baseUrl =
    env !== 'production' ? `https://admin-${env}.pokepay.jp` : `https://admin.pokepay.jp`;
  return baseUrl;
};

const ListTable = ({ applications, pagination, onChangePage }: Props) => {
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.Cell size="2">状態</Table.Cell>
          <Table.Cell size="5">タイトル</Table.Cell>
          <Table.Cell size="5">URL</Table.Cell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {applications?.map((application) => (
          <Table.Row key={application.id}>
            <Table.Cell>
              <StatusBadge status={application.status} />
            </Table.Cell>
            <Table.Cell>
              <Link to={`/organizations/application-form/${application.id}`}>
                {application.title}
              </Link>
            </Table.Cell>
            <Table.Cell>
              <LinkText
                href={`${getBaseUrl()}/public/${application.issuer_organization_code}/form/${
                  application.id
                }`}
                target="_blank"
              >
                {application.status === 'active' &&
                  `${getBaseUrl()}/public/${application.issuer_organization_code}/form/${application.id}`}
              </LinkText>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      <Table.Footer>
        <Table.Row noBorder>
          <Table.Cell colSpan="4" align="center" styles={{ paddingTop: '16px' }}>
            <Pager pagination={pagination} onChangePage={onChangePage} />
          </Table.Cell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default ListTable;
